import React from 'react'

//Retun the footer
const Footer = props => {
    return (
        <div className="footer_wrapper">
            <div className="footer_text">Copyright @2019 BigFM. All Rights Reserved</div>
        </div>

    )
}

export default Footer;


// WEBPACK FOOTER //
// ./web/components/common/Footer.jsx